import React from 'react';
import { Link } from 'react-router-dom';
import { SearchIcon, HomeIcon, MapIcon, TrendingUpIcon, ShieldCheckIcon, UsersIcon, CameraIcon, FileTextIcon } from 'lucide-react';
import ListingCard from '../components/ListingCard';
import { mockListings } from '../utils/mockData';
import { useLanguage } from '../contexts/LanguageContext';
const HomePage = () => {
  const {
    t
  } = useLanguage();
  // Get featured approved listings only
  const featuredListings = mockListings.filter(listing => listing.featured && listing.status === 'approved');
  return <div className="w-full bg-white" data-id="element-664">
      {/* Hero Section */}
      <section className="relative h-[600px] bg-gradient-to-br from-[rgb(var(--color-primary))] to-[rgb(var(--color-primary-dark))]" data-id="element-665">
        <div className="absolute inset-0 bg-black opacity-20" data-id="element-666"></div>
        <div className="absolute inset-0 bg-cover bg-center opacity-30" style={{
        backgroundImage: "url('https://images.unsplash.com/photo-1564013799919-ab600027ffc6?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1470&q=80')"
      }} data-id="element-667"></div>
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-full flex flex-col justify-center" data-id="element-668">
          <div className="text-center max-w-3xl mx-auto" data-id="element-669">
            <h1 className="text-4xl sm:text-5xl md:text-6xl font-bold text-white mb-6 leading-tight" data-id="element-670">
              {t.hero.title}
            </h1>
            <p className="text-xl text-white/90 mb-8" data-id="element-671">{t.hero.subtitle}</p>
            <div className="bg-white p-4 rounded-xl shadow-2xl max-w-2xl mx-auto" data-id="element-672">
              <div className="flex flex-col sm:flex-row gap-2" data-id="element-673">
                <div className="flex-grow" data-id="element-674">
                  <div className="relative" data-id="element-675">
                    <input type="text" placeholder={t.hero.searchPlaceholder} className="w-full pl-10 pr-4 py-3 border border-gray-200 rounded-lg focus:ring-2 focus:ring-primary focus:border-transparent" data-id="element-676" />
                    <SearchIcon className="absolute left-3 top-3.5 h-5 w-5 text-gray-400" data-id="element-677" />
                  </div>
                </div>
                <Link to="/browse" className="btn-primary whitespace-nowrap" data-id="element-678">
                  {t.hero.searchButton}
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section className="py-16 bg-gray-50" data-id="element-679">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-680">
          <div className="text-center mb-12" data-id="element-681">
            <h2 className="text-3xl font-bold text-gray-900 mb-4" data-id="element-682">
              {t.features.title}
            </h2>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-683">
              {t.features.subtitle}
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-684">
            <div className="bg-white rounded-xl p-8 shadow-sm hover:shadow-md transition-shadow" data-id="element-685">
              <div className="w-12 h-12 bg-primary/10 rounded-lg flex items-center justify-center mb-4" data-id="element-686">
                <ShieldCheckIcon className="h-6 w-6 text-primary" data-id="element-687" />
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-2" data-id="element-688">
                {t.features.verified.title}
              </h3>
              <p className="text-gray-600" data-id="element-689">{t.features.verified.description}</p>
            </div>
            <div className="bg-white rounded-xl p-8 shadow-sm hover:shadow-md transition-shadow" data-id="element-690">
              <div className="w-12 h-12 bg-accent/10 rounded-lg flex items-center justify-center mb-4" data-id="element-691">
                <UsersIcon className="h-6 w-6 text-accent" data-id="element-692" />
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-2" data-id="element-693">
                {t.features.community.title}
              </h3>
              <p className="text-gray-600" data-id="element-694">
                {t.features.community.description}
              </p>
            </div>
            <div className="bg-white rounded-xl p-8 shadow-sm hover:shadow-md transition-shadow" data-id="element-695">
              <div className="w-12 h-12 bg-primary/10 rounded-lg flex items-center justify-center mb-4" data-id="element-696">
                <TrendingUpIcon className="h-6 w-6 text-primary" data-id="element-697" />
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-2" data-id="element-698">
                {t.features.insights.title}
              </h3>
              <p className="text-gray-600" data-id="element-699">{t.features.insights.description}</p>
            </div>
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section className="py-16 bg-white" data-id="element-700">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-701">
          <div className="text-center mb-12" data-id="element-702">
            <h2 className="text-3xl font-bold text-gray-900 mb-4" data-id="element-703">
              {t.services.title}
            </h2>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-704">
              {t.services.subtitle}
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-705">
            <Link to="/services" className="group bg-gradient-to-br from-blue-50 to-blue-100 rounded-2xl p-8 hover:shadow-lg transition-all" data-id="element-706">
              <div className="w-14 h-14 bg-white rounded-xl flex items-center justify-center mb-4 group-hover:scale-110 transition-transform" data-id="element-707">
                <CameraIcon className="h-7 w-7 text-primary" data-id="element-708" />
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-3" data-id="element-709">
                {t.services.photography.title}
              </h3>
              <p className="text-gray-700 mb-4" data-id="element-710">
                {t.services.photography.description}
              </p>
              <span className="text-primary font-medium flex items-center group-hover:translate-x-2 transition-transform" data-id="element-711">
                {t.services.photography.learnMore}
              </span>
            </Link>
            <Link to="/services" className="group bg-gradient-to-br from-green-50 to-green-100 rounded-2xl p-8 hover:shadow-lg transition-all" data-id="element-712">
              <div className="w-14 h-14 bg-white rounded-xl flex items-center justify-center mb-4 group-hover:scale-110 transition-transform" data-id="element-713">
                <FileTextIcon className="h-7 w-7 text-green-600" data-id="element-714" />
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-3" data-id="element-715">
                {t.services.valuation.title}
              </h3>
              <p className="text-gray-700 mb-4" data-id="element-716">
                {t.services.valuation.description}
              </p>
              <span className="text-green-600 font-medium flex items-center group-hover:translate-x-2 transition-transform" data-id="element-717">
                {t.services.valuation.learnMore}
              </span>
            </Link>
          </div>
        </div>
      </section>

      {/* Property Types Section */}
      <section className="py-16 bg-gray-50" data-id="element-718">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-719">
          <h2 className="text-3xl font-bold text-center text-gray-900 mb-12" data-id="element-720">
            {t.propertyTypes.title}
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-721">
            <Link to="/browse?type=house" className="group relative h-80 rounded-2xl overflow-hidden shadow-lg" data-id="element-722">
              <img src="https://images.unsplash.com/photo-1564013799919-ab600027ffc6?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1470&q=80" alt="Houses" className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110" data-id="element-723" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent" data-id="element-724"></div>
              <div className="absolute bottom-0 left-0 right-0 p-8" data-id="element-725">
                <div className="flex items-center justify-between" data-id="element-726">
                  <div className="flex items-center" data-id="element-727">
                    <HomeIcon className="h-8 w-8 text-white mr-3" data-id="element-728" />
                    <h3 className="text-3xl font-bold text-white" data-id="element-729">
                      {t.propertyTypes.houses}
                    </h3>
                  </div>
                  <span className="bg-white text-primary px-4 py-2 rounded-full text-sm font-medium group-hover:bg-primary group-hover:text-white transition-colors" data-id="element-730">
                    {t.propertyTypes.explore}
                  </span>
                </div>
              </div>
            </Link>
            <Link to="/browse?type=land" className="group relative h-80 rounded-2xl overflow-hidden shadow-lg" data-id="element-731">
              <img src="https://images.unsplash.com/photo-1500382017468-9049fed747ef?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1632&q=80" alt="Land" className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110" data-id="element-732" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent" data-id="element-733"></div>
              <div className="absolute bottom-0 left-0 right-0 p-8" data-id="element-734">
                <div className="flex items-center justify-between" data-id="element-735">
                  <div className="flex items-center" data-id="element-736">
                    <MapIcon className="h-8 w-8 text-white mr-3" data-id="element-737" />
                    <h3 className="text-3xl font-bold text-white" data-id="element-738">
                      {t.propertyTypes.land}
                    </h3>
                  </div>
                  <span className="bg-white text-primary px-4 py-2 rounded-full text-sm font-medium group-hover:bg-primary group-hover:text-white transition-colors" data-id="element-739">
                    {t.propertyTypes.explore}
                  </span>
                </div>
              </div>
            </Link>
          </div>
        </div>
      </section>

      {/* Featured Properties Section */}
      <section className="py-16 bg-white" data-id="element-740">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-741">
          <div className="flex justify-between items-center mb-12" data-id="element-742">
            <h2 className="text-3xl font-bold text-gray-900" data-id="element-743">
              {t.featured.title}
            </h2>
            <Link to="/browse" className="text-primary hover:text-[rgb(var(--color-primary-dark))] font-medium flex items-center group" data-id="element-744">
              {t.featured.viewAll}
              <span className="ml-2 transform group-hover:translate-x-1 transition-transform" data-id="element-745">
                →
              </span>
            </Link>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-746">
            {featuredListings.map(listing => <ListingCard key={listing.id} listing={listing} data-id="element-747" />)}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 bg-gradient-to-br from-primary to-[rgb(var(--color-primary-dark))]" data-id="element-748">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-749">
          <h2 className="text-3xl font-bold text-white mb-6" data-id="element-750">{t.cta.title}</h2>
          <p className="text-xl text-white/90 mb-8 max-w-2xl mx-auto" data-id="element-751">
            {t.cta.subtitle}
          </p>
          <Link to="/create-listing" className="inline-block bg-white text-primary hover:bg-gray-50 font-bold px-8 py-4 rounded-lg transition-all duration-200 shadow-lg hover:shadow-xl" data-id="element-752">
            {t.cta.button}
          </Link>
        </div>
      </section>
    </div>;
};
export default HomePage;